import { SUPPORTED_LANGS } from '../locale'

// Globbed rather than listed so adding a language is a matter of dropping in
// one JSON file; anything not in SUPPORTED_LANGS is ignored.
const modules = import.meta.glob('./*.json', { eager: true })

const strings = {}

for (const [path, module] of Object.entries(modules)) {
    const lang = path.replace('./', '').replace('.json', '')
    if (SUPPORTED_LANGS.includes(lang)) {
        strings[lang] = module.default
    }
}

export default strings
